import { css } from "lit";

export const style = css`
		.host {
			padding: 5px 0;
			line-height: normal;
		}

		.message {
			display: flex;
			flex-direction: row;
			border: 1px solid var(--og-border-color);
			border-radius: var(--og-base-radius);
			user-select: text;
		}

		.message-content > :first-child { margin-top: 0; }
		.message-content > :last-child { margin-bottom: 0; }
		.message-content .emoji {
			width: 1em;
		}

		.message-left {
			padding: 10px;
			display: flex;
			flex-direction: column;
			justify-content: flex-start;
			align-items: center;
			flex: 0 0 40px;
			white-space: nowrap;
			border-right: 1px solid var(--og-border-color);
			gap: 10px;
		}

		.message-avatar {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 25px;
			height: 25px;
			border-radius: 50%;
			position: relative;
			border: 1px solid var(--og-border-color);
		}

		.message-content {
			flex: 1;
			align-self: center;
			color: var(--og-text-color);
			padding: 5px;
		}

		.message-role-name {
			font-size: 0.7em;
		}

		.view-placeholder {
			white-space: nowrap;
			margin-bottom: 5px;
			border: 1px solid var(--og-border-color);
    		border-radius: var(--og-base-radius);
		}

		.loader {
			text-align: center;
		}
		.loader img {
			height: 30px;
		}

		.message-attachments {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
			margin-top: 8px;
		}

		.message-attachment {
			max-width: 200px;
			max-height: 200px;
			border: 1px solid var(--og-border-color);
			border-radius: var(--og-base-radius);
			object-fit: contain;
			cursor: pointer;
		}

		/* a text file attachment: download link chip */
		.message-attachment-file {
			display: inline-flex;
			align-items: center;
			gap: 6px;
			padding: 4px 10px;
			border: 1px solid var(--og-border-color);
			border-radius: var(--og-base-radius);
			color: inherit;
			text-decoration: none;
			font-size: 0.9em;
		}

		.message-attachment-file:hover {
			background-color: var(--og-colortype-gray-background-color);
		}

		/* live progress of an answer being generated (see _renderProgress) */
		.progress {
			display: flex;
			flex-direction: column;
			gap: 6px;
			font-size: 0.85em;
		}
		.progress-current {
			display: flex;
			align-items: center;
			gap: 8px;
		}
		.progress-loader {
			height: 18px;
		}
		.progress-muted {
			opacity: 0.6;
			font-variant-numeric: tabular-nums;
		}
		.progress-step {
			padding: 2px 8px;
			border-left: 2px solid var(--og-border-color);
		}
		.progress-step-head {
			display: flex;
			flex-wrap: wrap;
			gap: 8px;
		}
		.progress-thinking summary {
			cursor: pointer;
			opacity: 0.6;
		}
		.progress-thinking div {
			white-space: pre-wrap;
			padding: 6px 8px;
			border-radius: 4px;
			background: rgba(127, 127, 127, 0.1);
		}
		.progress-stale {
			color: var(--og-warning-color, #d98c00);
		}
	`
